export default "__VITE_ASSET__6ea5855f__"